import React from 'react';
import { Link } from 'react-router-dom';
import '../../css/services/ServicesPage.css';
import img7 from '../../img/servicepage/7.jpg';
// import img8 from '../../img/servicepage/8.jpg';
// import img9 from '../../img/servicepage/9.jpg';
import img10 from '../../img/servicepage/10.png';
import markerimg from '../../img/servicepage/marker.png';
import acornsimg from '../../img/servicepage/acorns.png';


const ServicesPage = () => {
  // Replace these with your actual image URLs
  const images = {
    hero: img7,
    ambassadors: acornsimg,
    influencers: markerimg,
    research: img10
  };
    

  return (
    <div className="services-page">
      {/* Hero Section */}
      <section className="services-hero">
        <div className="hero-content">
          <div className="hero-text">
            <h1>Built for Brands That Want to Own the College Market</h1>
            <p className="hero-subhead">
              We design, run, and scale student-powered campaigns. No guesswork, no fluff. 
              Just real students, real reach, and real results.
            </p>
          </div>
          <div className="hero-image-container">
            <img 
              src={images.hero} 
              alt="Students collaborating on campus" 
              className="hero-image"
            />
          </div>
        </div>
      </section>

      {/* Intro Section */}
      <section className="services-intro">
        <p className="intro-text">
          Our offerings are structured to meet you where you are, whether you're testing
          a few campuses or launching across the country.
        </p>
      </section>

      {/* Service Snapshot Tiles */}
      <section className="service-snapshots">
        <div className="snapshot-grid">
          <div className="snapshot-card">
            <h3>Ambassador Programs</h3>
            <p>
              Launch a student-led campaign that drives awareness, loyalty, and conversions,
              all managed by us.
            </p>
          </div>

          <div className="snapshot-card">
            <h3>Influencer & Creator Campaigns</h3>
            <p>
              Get scalable content from vetted student creators across our national network.
            </p>
          </div>

          <div className="snapshot-card">
            <h3>Campus Research & Surveys</h3>
            <p>
              Understand your student audience better than your competitors do and turn 
              that into marketing gold.
            </p>
          </div>
        </div>
      </section>

      {/* Ambassador Programs Section */}
      <section className="service-detail ambassador-section">
        <div className="detail-content">
          <div className="text-content">
            <h2>Full-Service Ambassador Programs: Managed by Experts, Powered by Students</h2>
            <p className="subhead">
              We've built, scaled, and optimized programs across 100+ campuses. From recruitment 
              to reporting, we handle the entire pipeline so you don't have to.
            </p>
            <ul className="key-points">
              <li>
                <strong>Strategic Recruitment</strong>
                <p>We recruit from our vetted network of 2,500+ students across 145+ campuses. We target the right majors, orgs, and archetypes to represent your brand.</p>
              </li>
              <li>
                <strong>Training & Activation</strong>
                <p>Every ambassador gets onboarded through our proven process: trained for trust, performance, and compliance with campus policies.</p>
              </li>
              <li>
                <strong>Management & Reporting</strong>
                <p>We manage hours, output, incentives, and compliance. You get clean reports, real ROI, and no headaches.</p>
              </li>
              <li>
                <strong>Fast Launch, Real Results</strong>
                <p>Most programs launch within 30 days. Whether you're testing 5 campuses or scaling to 100, we have you covered.</p>
              </li>
            </ul>
            <Link to="/brands">
              <button className="cta-button">Launch Your Ambassador Program</button>
            </Link>
          </div>
          <img 
            src={images.ambassadors} 
            alt="Campus ambassador program" 
            className="detail-image"
          />
        </div>
      </section>

      {/* Influencer Campaigns Section */}
      <section className="service-detail influencer-section">
        <div className="detail-content reverse">
          <div className="text-content">
            <h2>Student-Created Content That Converts</h2>
            <p className="subhead">
              We source, brief, and manage student creators who actually know how to reach 
              their peers, because they are their peers.
            </p>
            <ul className="key-points">
              <li>
                <strong>Vetted Student Creators</strong>
                <p>We maintain a growing directory of college content creators, each vetted for professionalism, niche, and brand fit.</p>
              </li>
              <li>
                <strong>Authentic, Platform-Native Content</strong>
                <p>From TikToks to UGC-style product reviews, our creators know how to speak Gen Z fluently.</p>
              </li>
              <li>
                <strong>You Set the Goals and We Handle the Rest</strong>
                <p>Whether it's awareness, traffic, or conversions, we handle briefs, deliverables, and logistics. You receive usage rights, reporting, and peace of mind.</p>
              </li>
              <li>
                <strong>Built for Scale</strong>
                <p>Need 10 creators? Need 200? Whatever the case, we'll handle it.</p>
              </li>
            </ul>
            <Link to="/brands">
              <button className="cta-button">Explore the Creator Network</button>
            </Link>
          </div>
          <img 
            src={images.influencers} 
            alt="Student influencer content creation" 
            className="detail-image"
          />
        </div>
      </section>

      {/* Research Section */}
      <section className="service-detail research-section">
        <div className="detail-content">
          <div className="text-content">
            <h2>Know the Student Market Like You Built It</h2>
            <p className="subhead">
              We design and deploy targeted research studies across our student network, 
              giving your team firsthand insight into what Gen Z actually thinks, wants, and does.
            </p>
            <ul className="key-points">
              <li>
                <strong>Custom Survey Design</strong>
                <p>We help you ask the right questions and ensure they get answered by the right people.</p>
              </li>
              <li>
                <strong>Targeted Distribution</strong>
                <p>Access students by major, school, org affiliation, location, or behavior. All responses are verified and segmented for your use.</p>
              </li>
              <li>
                <strong>Actionable Insights</strong>
                <p>We turn raw data into clear takeaways: perfect for internal strategy, investor decks, or marketing collateral.</p>
              </li>
            </ul>
            <Link to="/brands">
              <button className="cta-button">Get Research Support</button>
            </Link>
          </div>
          <img 
            src={images.research} 
            alt="Market research with students" 
            className="detail-image"
          />
        </div>
      </section>
    </div>
  );
};

export default ServicesPage;